import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StatsBar from "@/components/site/StatsBar";
import ModelsComparison from "@/components/site/ModelsComparison";
import BuiltForOutback from "@/components/site/BuiltForOutback";
import VideoGallery from "@/components/site/VideoGallery";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import TestDriveForm from "@/components/site/TestDriveForm";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function ProductPage() {
  return (
    <main data-testid="product-page" className="min-h-screen bg-background text-foreground">
      <Header />
      <Hero />
      <StatsBar />
      <ModelsComparison />
      <Gallery />
      <BuiltForOutback />
      <VideoGallery />
      <Testimonials />
      <TestDriveForm />
      <FAQ />
      <Footer />
    </main>
  );
}
